<template>
  <div class="container">
    <div>
      <div>
        <h1>Generation</h1>
        <div class="content1">
          <h2>Structure-based</h2>
          <p>The structure-based module generates bioactive molecules using either a protein structure file (PDB format) or a PDB ID as input. Users can download PDB files from the RCSB Protein Data Bank
              <el-link type="success" style="font-size: 18px;" :href=link1>https://www.rcsb.org/</el-link>.</p>
        </div>
        <br>
        <div class="content1">
            <h2>Sequence-based</h2>
            <p>The sequence-based module takes a protein sequence as input. Users can obtain amino acid sequences
                in FASTA format from UniProt (<el-link type="success" style="font-size: 18px;" :href=link3>https://www.uniprot.org/</el-link>).</p>
        </div>
        <div class="content1">
          <h2>Phar-based</h2>
          <p>The pharmacophore-based module performs constraint-guided molecular generation using a user-provided pharmacophore hypothesis. Pharmacophore models can be constructed using tools such as Align-it
              (<el-link type="success" style="font-size: 18px;" :href=link2>
              https://anaconda.org/bioconda/align_it</el-link>),
              or other compatible software. Only files in the *.phar format are accepted. An example *.phar file can be downloaded from the AIDrugDesigner website:
              <el-link type="success" style="font-size: 18px;" :href=link4>https://www.csuligroup.com/AIDrugDesigner/#/generation/phar-based</el-link>.
          </p>
        </div>
        <br>
        <div class="content2">
          <h2>Property-based</h2>
          <p>The property-based method generates desired properties molecules based on the input conditions.</p>
          <p>Parameter description.</p>
          <el-table
                  :data="tableData"
                  border
                  style="width: 100%">
            <el-table-column
                    prop="p"
                    label="property"
                    width="180"
                    align="center">
            </el-table-column>
            <el-table-column
                    prop="d1"
                    label="description"
                    width="300"
                    header-align="center">
            </el-table-column>
            <el-table-column
                    prop="d2"
                    label="default"
                    align="center">
            </el-table-column>
            <el-table-column
                    prop="r"
                    label="remark"
                    header-align="center">
            </el-table-column>
          </el-table>
        </div>
        <br>
        <div class="content2">
          <h2>Linker-based</h2>
            <p>Users provide molecular fragments in SMILES format with defined attachment points. The connection sites must be explicitly marked using the wildcard atom [*], indicating where the linker will be attached. For example: [*]C1=CC=C(C)C=C1 and [*]C1=CC=CC=C1. Users can further specify constraints on the generated linker, including linker length, number of aromatic rings, and hydrogen bond donor and acceptor counts.</p>
          <p>Linker Design Parameters</p>
            <el-table
                  :data="tableData1"
                  border
                  style="width: 100%">
            <el-table-column
                    prop="p1"
                    label="property"
                    width="180"
                    align="center">
            </el-table-column>
            <el-table-column
                    prop="d11"
                    label="description"
                    width="300"
                    header-align="center">
            </el-table-column>
            <el-table-column
                    prop="d21"
                    label="default"
                    align="center">
            </el-table-column>
            <el-table-column
                    prop="r1"
                    label="remark"
                    header-align="center">
            </el-table-column>
          </el-table>
        </div>
      </div>
      <br>
      <div >
        <h1>Optimization</h1>
        <div class="content2">
            <p style="font-weight: bold;">Input</p>
            <p>Users can upload a SMILES file (*.txt) or enter a SMILES string directly for optimization.</p>
            <p style="font-weight: bold;">LogP</p>
            <p>LogP represents the n-octanol/water partition coefficient of a molecule and reflects molecular lipophilicity. Higher LogP values indicate increased hydrophobicity.</p>
            <p style="font-weight: bold;">Solubility</p>
            <p>Molecular solubility is closely related to lipophilicity. Reducing excessive LogP values can improve aqueous solubility.</p>
            <p style="font-weight: bold;">QED</p>
            <p>Quantitative Estimate of Drug-likeness (QED) is a composite metric used to evaluate the drug-likeness of a compound. Higher QED values indicate greater drug-likeness.</p>
            <p style="font-weight: bold;">Synthetic Accessibility (SA)</p>
            <p>Synthetic Accessibility (SA) estimates the ease of chemical synthesis of drug-like molecules. SA scores range from 1 (easy to synthesize) to 10 (difficult to synthesize).</p>






            <!--          <p>Upload SMILES.txt or input SMILES for your optimization.</p>-->
<!--          <p>The logP show the n-octanol/water distribution coefficient of molecule. The larger the logP,-->
<!--            the more lipophilic the compound is.</p>-->
<!--          <p>The solubility show the n-octanol/water distribution coefficient of molecule. The larger the-->
<!--            hydrophilic, the more hydrophilic it is.</p>-->
<!--          <p>The quantitative estimate of drug-likeness (QED) is a measure of drug-likeness. The larger the-->
<!--            QED, the more attractive the compound. </p>-->
<!--          <p>Synthetic accessibility (SA) is designed to estimate ease of synthesis of drug-like molecules. The SA is ranged-->
<!--            from 1 (easy to make) to 10 (very difficult to make).</p>-->
        </div>
      </div>


    </div>
  </div>

</template>

<script>

  export default {
  name: "Tutorial",
  data() {
    return {
      link1:"https://www.rcsb.org/",
      link2:'https://anaconda.org/bioconda/align_it',
      link3:'https://www.uniprot.org/',
      link4:'https://www.csuligroup.com/AIDrugDesigner/#/generation/phar-based',
      tableData: [
        { p:'Molecular Weight',
          d1:'Range of molecular weight for generated molecules.',
          d2:'300-500',
          r:'Based on Lipinski’s Rule of Five (RO5) and drug-likeness guidelines, acceptable molecular weight is typically within 100–600 Da.'
        },
        { p:'LogP',
          d1:'The n-octanol/water partition coefficient (logP) reflects molecular lipophilicity and influences membrane permeability.',
          d2:'0-5',
          r:'Higher values indicate increased hydrophobicity.'
        },
        { p:'QED',
          d1:'Quantitative Estimate of Drug-likeness (QED) integrates multiple physicochemical properties to evaluate drug-likeness.',
          d2:'0.4-1.0',
          r:'Higher QED values indicate greater drug-likeness.'
        },
        { p:'TPSA',
          d1:'Topological Polar Surface Area (TPSA) represents the sum of surface areas of polar atoms in a molecule and is associated with cell permeability.',
          d2:'0-140',
          r:'Based on Veber’s rule.'
        },
        { p:'HBA',
          d1:'Number of hydrogen bond acceptors.',
          d2:'0-10',
          r:'Based on Lipinski’s Rule of Five.'
        },
        { p:'HBD',
          d1:'Number of hydrogen bond donors.',
          d2:'0-5',
          r:'Based on Lipinski’s Rule of Five.'
        },
      ],
      tableData1: [
        { p1:'length',
          d11:'Number of atoms included in the generated linker.',
          d21:'2-20',
          r1:'The range is set according to general drug design requirements.'
        },
        { p1:'AR (Aromatic Rings)',
          d11:'Number of aromatic rings in the linker.',
          d21:'0-3',
          r1:'Limit aromatic rings to reduce rigidity and hydrophobicity.'
        },
        { p1:'HBA',
          d11:'Number of hydrogen bond acceptors.',
          d21:'0-10',
          r1:'Based on Lipinski’s Rule of Five.'
        },
        { p1:'HBD',
          d11:'Number of hydrogen bond donors.',
          d21:'0-5',
          r1:'Based on Lipinski’s Rule of Five.'
        },
      ]
    }
  }
}
</script>

<style scoped>
.container {
  max-width: 1160px;
  margin: 0 auto;
}
  p,h1,h2{
    text-align: left;
  }
  p{
    line-height: 1.5em;
  }
.content1{
  box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
  background-color: RGB(255,255,255);
  border-radius: 10px;
  padding: 10px;
  /*height: 200px;*/
}
.content2{
  box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
  background-color: RGB(255,255,255);
  border-radius: 10px;
  padding: 10px;
  padding-bottom: 1px;
}
</style>
